import $ from 'jquery';
import { CHECKED,DISABLED_CHECKBOX } from '../constants/classes';
import Notifications from '../global/Notifications';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    DEFAULT_CHECKBOX: '.js-default-checkbox',
    CUSTOM_CHECKBOX: '.js-custom-checkbox',
    PRODUCT_NAME: 'product-name',
    IN_STOCK_ATTR: 'data-in-stock'
};

/**
 * Hide Default browser checkbox
 * Control it using label and custom style
 * 
 *
 * @class CheckboxDependenciesView
 * @constructor
 */
export default class CustomCheckBoxView {
    constructor($element) {
        console.log('Constructing');
        this.$element = $element;
        return this.setupHandlers()
            .createChildren()
            .enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {
        this.onDefaultCheckBoxClickHandler = this.onDefaultCheckBoxClick.bind(this);
        this.onCustomCheckBoxClickHandler = this.onCustomCheckBoxClick.bind(this);
        this.qtyOutOfStockHandler = this.onQtyOutOfStock.bind(this);
        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.$defaultCheckbox = this.$element.find(SELECTORS.DEFAULT_CHECKBOX);
        this.$customCheckbox = this.$element.find(SELECTORS.CUSTOM_CHECKBOX);
        this.$productNameElement = document.getElementById(SELECTORS.PRODUCT_NAME);
        this.notifications = new Notifications();
        return this;
    }

    /**
     *
     * @method onParentClick
     * @public
     * @chainable
     */
    onDefaultCheckBoxClick(e) {
        return this;
    }

    /**
     * Toggles custom checkbox style
     * Triggers a click on default checkbox
     *
     * @method onParentClick
     * @public
     * @chainable
     */
     onCustomCheckBoxClick(e) {
        if(this.$customCheckbox.hasClass(DISABLED_CHECKBOX)) {
            return false;
        }
        this.$defaultCheckbox.click();
       
            if(this.$customCheckbox.hasClass(CHECKED)){
                this.$customCheckbox.removeClass(CHECKED)
                this.notifications.resetMessages();
            } else{
                this.$customCheckbox.addClass(CHECKED) 
            }
         
        return this;
    }

    /**
     * 
     * Loads disabled checkbox
     * icon when qty out of stock
     *
     * @method onQtyOutOfStock
     * @public
     * @chainable
     */
     onQtyOutOfStock() {
         let inStockQty;
        inStockQty = parseInt(this.$productNameElement.getAttribute(SELECTORS.IN_STOCK_ATTR));
        if (inStockQty === 0) {
                 this.$customCheckbox.addClass(DISABLED_CHECKBOX);  
                 }                 
         }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {
        this.$defaultCheckbox.on('change', this.onDefaultCheckBoxClickHandler);
        this.$customCheckbox.on('click', this.onCustomCheckBoxClickHandler);
        this.qtyOutOfStockHandler();
        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        this.$defaultCheckbox.off('change', this.onDefaultCheckBoxClickHandler);
        this.$customCheckbox.off('change', this.onCustomCheckBoxClickHandler);
        return this;
    }
}